<div class="container">
  <h1 nxHeadline size="xl" class="nx-font-weight-bold">{{ 'Your payment verification is in progress' | transloco }}</h1>

  <nx-icon class="progress-icon" name="check-circle" size="l"></nx-icon>

  <nx-message context="info">
    {{ 'Your payment has been successfully received by our team. An email with the payment result will be sent to you shortly.' | transloco }}
  </nx-message>
</div>
